import { fetchMedMij, fetchSuggestions } from "../services/pgoApi.js";

export const vzvzFormHandler = () => ({
    modalOpen: false,
    fetching: false,
    error: false,
    form: {
        name: '',
        city: ''
    },
    data: [],
    suggestions: [],

    init() {
        this.$watch('form.city', () => this.getSuggestions());
        this.$watch('modalOpen', (modalOpen) => modalOpen && this.clearData())
    },

    /**
     * Submit the form with the name of the organisation and city
     */
    async sendForm() {
        const { name, city } = this.form;
    
        if (name.length < 3 || city.length < 3) return;
    
        this.fetching = true;
        this.data = [];
    
        try {
            const result = await fetchMedMij(name, city);
    
            if (result) {
                this.fetching = false;
                this.data = result;
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            this.error = true;
        } finally {
            this.fetching = false;
        }
    },    

    /**
     * Receive all the city suggestions
     */
    async getSuggestions() {
        const {city} = this.form;
        

        if (!city.length) return;

        try {
            const result = await fetchSuggestions(city);

            if (result && result.response && result.response.docs) {
                let suggestions = result.response.docs.map(doc => doc.weergavenaam.split(',').at(0));

                if (suggestions.includes(city)) {
                    this.suggestions = [];
                    return this.sendForm();
                }
        
                this.suggestions = suggestions;
            }
        } catch (error) {
            console.error("Error submitting suggestions:", error);
            this.error = true;
        }
    },

    /**
     * Resets the form fields.
     */
    clearData() {
        this.form = {
            name: '',
            city: ''
        };
        this.data = [];
    },
});